import React from "react";
import "./news.css";
import NavBar from "../../Layout/NavBar/NavBar";
import actus from "../../Common/news.json";
import { Navigate, useNavigate } from "react-router-dom";

const News = (props) => {
  const openMenu = props.openMenu;
  const onOpen = props.onOpen;
  const t = props.language;
  const news = actus.news;
  const navigate = useNavigate;

  return (
    <div className="news">
      <NavBar
        language={props.language}
        languages={props.languages}
        openMenu={openMenu}
        onOpen={onOpen}
        black={true}
      />
      {!openMenu ? (
        <>
          <div className="filler"></div>
          <div
            className="text__team "
            style={{ color: "black", marginTop: "2rem" }}
          >
            {t("news")}
            <span className="line__team"></span>
          </div>
          <div className="team__desc--wrap">
            <p className="team__desc" style={{ marginTop: "3rem" }}>
              {/* {t("carrers_text")} */}
            </p>
          </div>
          <div>
            <div className="news__wrap">
              {news.map((element, index) => {
                return (
                  <div className="news__card" key={index}>
                    <span className="news__date">
                      {element[`date_${t("news").toLowerCase()}`]}
                    </span>
                    {/* src={require(`../../Assets/Buildings/${asset.name}1.jpg`)} */}
                    <img
                      className="img__news"
                      src={require(`../../Assets/Buildings/${element.image}`)}
                      alt=""
                    />
                    <span className="new_link">
                      {element[`name_${t("news").toLowerCase()}`]}
                    </span>
                    <a
                      className="news__link invest-btn"
                      href={`${element.link}`}
                    >
                      {t("dm")}
                    </a>
                  </div>
                );
              })}
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default News;
